import Image from "next/image";
import IMAGES from "@/public/assets/img";

const dataSecurityData = {
    heading: "Data Security: Our Top Priority",
    description:
      "We prioritize your data security. Credlix uses advanced encryption and strict confidentiality protocols. User data remains secure and confidential.",
    items: [
      {
        id: 1,
        title: "Secure Data",
        subtitle: "Advanced encryption.",
        icon: IMAGES.termsheet.secure,
      },
      {
        id: 2,
        title: "Confidentiality",
        subtitle: "Strict protocols.",
        icon: IMAGES.termsheet.document,
      },
    ],
  };

const DataSecurity = () => {
  const { heading, description, items } = dataSecurityData;

  return (
  <section>
  <div className="flex sm:flex-col items-stretch">
    {/* Left image */}
    <div className="w-1/2 sm:w-full">
      <Image
        src={IMAGES.termsheet.Values}
        alt="Security Illustration"
        width={611}
        height={548}
        className="w-full h-full object-cover"
      />
    </div>

    {/* Right content */}
    <div className="w-1/2 sm:w-full bg-[#022454] px-6 py-6 sm:px-3 flex flex-col justify-center">
      <h2 className="text-xxl font-bold text-white mb-1">{heading}</h2>
      <p className="text-xl text-white mb-6 w-2/3 md:w-full sm:w-full">{description}</p>

      <div className="flex sm:flex-row flex-wrap gap-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-white text-black rounded-lg px-3 py-4 w-2/6 md:w-auto sm:w-full"
          >
            <Image src={item.icon} alt={item.title} width={60} height={60} />
            <div>
              <h4 className="font-semibold text-lg my-2">{item.title}</h4>
              <p className="text-base text-gray-600">{item.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

  );
};

export default DataSecurity;
